import { call, put, select, takeLatest } from 'redux-saga/effects';
import { tagService } from './tag.service';
import { taskService } from '../tasks/task.service';
import {
  GET_TAGS, GET_TAGS_SUCCESS,
  CREATE_TAG, CREATE_TAG_SUCCESS,
  UPDATE_TAG, UPDATE_TAG_SUCCESS,
  DELETE_TAG, DELETE_TAG_SUCCESS,
} from './tag.types';
import { GET_TASKS_SUCCESS } from '../tasks/task.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

// Helper: refetch tasks so edited/deleted tag changes cascade to task cards
function* refreshTasks() {
  try {
    const tasks = yield select((state) => state.tasks.tasks);
    if (tasks && tasks.length > 0) {
      const projectId = tasks[0]?.project?._id || tasks[0]?.project;
      if (projectId) {
        const res = yield call(taskService.getTasks, { project: projectId });
        yield put({ type: GET_TASKS_SUCCESS, payload: res.data });
      }
    }
  } catch (e) {
    // Swallow — this is a best-effort refresh
  }
}

function* getTagsSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(tagService.getTags, payload);
    yield put({ type: GET_TAGS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createTagSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(tagService.createTag, payload);
    yield put({ type: CREATE_TAG_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* updateTagSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(tagService.updateTag, payload.id, payload.data);
    yield put({ type: UPDATE_TAG_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    // Cascade: refetch tasks so updated tag name/color appears on all task cards
    yield call(refreshTasks);
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* deleteTagSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    yield call(tagService.deleteTag, payload);
    yield put({ type: DELETE_TAG_SUCCESS, payload });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    // Cascade: refetch tasks so deleted tag is removed from all task cards
    yield call(refreshTasks);
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchTags() {
  yield takeLatest(GET_TAGS, getTagsSaga);
  yield takeLatest(CREATE_TAG, createTagSaga);
  yield takeLatest(UPDATE_TAG, updateTagSaga);
  yield takeLatest(DELETE_TAG, deleteTagSaga);
}
